import { useState, useEffect } from 'react';
import { IconWhirl } from '@tabler/icons-react';

// Icono por defecto (espiral) para vistas que no especifiquen uno.
const DefaultIcon = IconWhirl;

const TOTAL_SECONDS = 15 * 60;
const SIZE = 48;
const STROKE = 6;
const OUTER = SIZE / 2;
const INNER = OUTER - STROKE;
const CIRCUMFERENCE = 2 * Math.PI * INNER;

function getColor(remaining) {
  const pct = remaining / TOTAL_SECONDS;
  if (pct > 0.66) return '#30d158';
  if (pct > 0.33) return '#f87c2b';
  return '#ff453a';
}

export default function PedidoTiempo({ startTime, icon: Icon = DefaultIcon }) {
  const [remaining, setRemaining] = useState(() => {
    const elapsed = Math.floor((Date.now() - startTime) / 1000);
    return Math.max(0, TOTAL_SECONDS - elapsed);
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      setRemaining(Math.max(0, TOTAL_SECONDS - elapsed));
    }, 1000);
    return () => clearInterval(interval);
  }, [startTime]);

  const progress = remaining / TOTAL_SECONDS;
  const offset = CIRCUMFERENCE * (1 - progress);
  const isExpired = remaining === 0;
  const color = isExpired ? '#ff453a' : getColor(remaining);

  return (
    <div
      style={{
        position: 'relative',
        width: SIZE,
        height: SIZE,
      }}
    >
      {/* SVG ring */}
      <svg
        width={SIZE}
        height={SIZE}
        style={{
          position: 'absolute',
          inset: 0,
          transform: 'rotate(-90deg)',
        }}
      >
        {/* Track */}
        <circle
          cx={OUTER}
          cy={OUTER}
          r={INNER}
          fill="none"
          stroke="rgba(255,255,255,0.08)"
          strokeWidth={STROKE}
        />
        {/* Inner background matching the card surface */}
        <circle cx={OUTER} cy={OUTER} r={INNER} fill="#141414" />
        {/* Progress */}
        <circle
          cx={OUTER}
          cy={OUTER}
          r={INNER}
          fill="none"
          stroke={color}
          strokeWidth={STROKE}
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{
            transition: 'stroke-dashoffset 1s linear, stroke 0.8s ease',
          }}
        />
      </svg>

      {/* Spinning whirl — always rotating */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'whirl-spin 3s linear infinite',
        }}
      >
        <Icon
          size={18}
          strokeWidth={1.75}
          color={color}
          style={{
            transition: 'color 0.8s ease',
          }}
        />
      </div>

      <style>{`
        @keyframes whirl-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
